
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/online-adhd-testing",
      function () {
        return require("private-next-pages/online-adhd-testing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/online-adhd-testing"])
      });
    }
  